import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const PoliticalContributorFilterIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.1818 11V19"
        stroke={theme.colors.primary.c500}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 12.4546H14.2727C13.9352 12.4546 13.6115 12.5887 13.3728 12.8274C13.1341 13.066 13 13.3898 13 13.7273C13 14.0649 13.1341 14.3886 13.3728 14.6273C13.6115 14.866 13.9352 15 14.2727 15H16.0909C16.4285 15 16.7522 15.1341 16.9909 15.3728C17.2295 15.6115 17.3636 15.9352 17.3636 16.2728C17.3636 16.6103 17.2295 16.934 16.9909 17.1727C16.7522 17.4114 16.4285 17.5455 16.0909 17.5455H13"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="4" y="2" width="10" height="6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 12H4V15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="7" y="8" width="4" height="4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 2H16" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 15L9.5 15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default PoliticalContributorFilterIcon;
